import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" fillRule="evenodd" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 5v13h13v-3h1v4H1V4h4v1H2z" /><path clipRule="evenodd" d="M18 2H5v13h13V2zM4 1v15h15V1H4z" /><path d="M10 11V6l4 2.5-4 2.5z" /></svg>;